import script from "./IPDPharmacyInvoice.vue?vue&type=script&setup=true&lang=js"
export * from "./IPDPharmacyInvoice.vue?vue&type=script&setup=true&lang=js"

import "./IPDPharmacyInvoice.vue?vue&type=style&index=0&id=30e82cda&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30e82cda"]])

export default __exports__